<template>
  <div>
    <div class="list"
         v-for="(itme, index) in list"
         :key="index">
      <div class="list_title">{{ itme.title }}</div>
      <div class="list_main"
           v-for="(text, textindex) in itme.text"
           :key="textindex">
        <div class="maintext">{{ text }}</div>
      </div>
      <div class="maintext">
        四、当日挂号时间
        <ul>
          <li> · 上午号：当日11点之前</li>
          <li> · 下午号：当日16点之前</li>
          <li> · 白天号：当日16点之前</li>
          <li> · 全天号：当日18点之前</li>
          <li> · 夜班号：当日16点到18点之间</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      list: [
        {
          title: "掌上就医就诊指南",
          text: [
            "一、本院掌上就医指南，目前可以挂号，门诊缴费及报告查看。可以方便患者随时预约挂号。",
            "二、首次使用掌上医院就医时，需要添加就诊人信息。如果无法添加 ，请至窗口补全相应信息。",
            "三、同一个账号下，可以添加多个就诊人",
          ],
        },
      ],
    };
  },
  computed: {},
  created () { },
  mounted () { },
  watch: {},
  methods: {},
  components: {},
};
</script>

<style scoped>
.list {
  margin: 10px 10px;
}
ul {
  list-style-type: none;
  margin-left: 20px;
}
.list_title {
  font-size: 20px;
  margin-bottom: 10px;
}
/* .list_title:before {
  width: 3.5px;
  height: 20px;
  background-color: rgb(56, 171, 187);
  content: ".";
  color: rgb(56, 171, 187);
  margin-right: 10px;
  display: inline-block;
}
.list_main {
} */

.maintext {
  line-height: 22px;
  letter-spacing: 2px;
  margin-bottom: 5px;
}
</style>
